import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { RolesService } from '../_service/roles.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-roles',
  standalone: true,
  imports: [RouterModule, NgbModule, ReactiveFormsModule, FormsModule, CommonModule],
  templateUrl: './roles.component.html',
  styleUrl: './roles.component.scss'
})
export class RolesComponent implements OnInit {
  router = inject(Router)
  modal = inject(NgbModal)
  service = inject(RolesService)
  roles: any[] = [];
  role: any;
  permissions: any;
  selectedPermissions: any[] = [];
  name: any
  description: any
  permId: any;
  searchTerm: string = '';
  filteredRoles: any[] = [];

  // Loading states
  isLoadingRoles = false;
  isLoadingPermissions = false;
  isUpdatingRole = false;
  isDeletingRole = false;

  ngOnInit(): void {
    this.getRoles()
    this.getPermissions()
  }

  getRoles() {
    this.isLoadingRoles = true;
    this.service.getRoles().subscribe({
      next: (res: any) => {
        this.roles = res;
        this.filteredRoles = res;
        this.isLoadingRoles = false;
      },
      error: (err) => {
        console.log(err);
        this.isLoadingRoles = false;
      }
    });
  }

  getPermissions() {
    this.isLoadingPermissions = true;
    this.service.getPermissions().subscribe({
      next: (res) => {
        console.log(res);
        this.permissions = res;
        this.isLoadingPermissions = false;
      },
      error: (err) => {
        console.log(err);
        this.isLoadingPermissions = false;
      }
    });
  }

  createRole() {
    this.router.navigateByUrl('admin/roles_and_permissions/create_role')
  }

  edit(content: any, item: any) {
    this.role = item
    this.name = item.name
    this.description = item.description
    this.permId = item.id
    console.log(item.permissions)
    this.selectedPermissions = item.permissions
    this.modal.open(content, { centered: true }).result
  }

  isChecked(permId: number): boolean {
    return this.selectedPermissions.some(item => item.id === permId);
  }

  delete(id: any) {
    Swal.fire({
      title: 'Delete Role',
      text: 'Are you sure you want to delete this role?',
      icon: 'warning',
      confirmButtonText: 'Delete Role',
      cancelButtonText: 'Cancel',
      showCancelButton: true,
      confirmButtonColor: '#dc2626',
      cancelButtonColor: '#6b7280'
    }).then((result) => {
      if (result.isConfirmed) {
        this.isDeletingRole = true;
        this.service.deleteRole(id).subscribe({
          next: (res) => {
            Swal.fire('Deleted!', 'Role deleted successfully', 'success');
            this.isDeletingRole = false;
          },
          error: (err) => {
            Swal.fire('Failed!', err.error.message, 'error');
            this.isDeletingRole = false;
          },
          complete: () => {
            this.getRoles();
          }
        });
      }
    });
  }

  onCheckboxChange(event: Event, permissionId: any): void {
    const checkbox = event.target as HTMLInputElement;
    if (checkbox.checked) {
      // Add permission.id to the array
      this.selectedPermissions.push(permissionId);
    } else {
      // Remove permission.id from the array if unchecked
      this.selectedPermissions = this.selectedPermissions.filter(id => id !== permissionId);
    }
    // console.log(this.selectedPermissions); // For debugging
  }

  update() {
    this.isUpdatingRole = true;
    const data = {
      name: this.name,
      description: this.description,
      permissions: this.selectedPermissions
    };

    console.log(data);

    this.service.updateRole(data, this.permId).subscribe({
      next: (res) => {
        Swal.fire('Success!', 'Role updated successfully', 'success');
        this.isUpdatingRole = false;
      },
      error: (err) => {
        Swal.fire('Failed!', err.error.message, 'error');
        this.isUpdatingRole = false;
      },
      complete: () => {
        this.getRoles();
        this.modal.dismissAll();
      }
    });
  }

  formatPermission(permission: string): string {
    // Split the permission string by the dot and underscore
    const [context, action] = permission.split('.');

    // Replace underscores with spaces and capitalize the words
    const formattedAction = action
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

    // Return the formatted string with the example suffix
    return `${formattedAction}`;
  }

  trackByPermissionId(index: number, item: any): any {
    return item?.id || index;
  }

  searchRoles(event: any) {
    const searchTerm = event.target.value.toLowerCase();
    this.filteredRoles = this.roles.filter((role: any) =>
      role.name.toLowerCase().includes(searchTerm) ||
      (role.description || '').toLowerCase().includes(searchTerm)
    );
  }

}
